import React, { useCallback } from 'react';

function getAudioCtx() {
  try { return new (window.AudioContext || window.webkitAudioContext)(); } catch(e) { return null; }
}

function playSwipeSound() {
  const ctx = getAudioCtx(); if (!ctx) return;
  const osc = ctx.createOscillator(), g = ctx.createGain();
  osc.connect(g); g.connect(ctx.destination);
  osc.type = 'sine';
  osc.frequency.setValueAtTime(380, ctx.currentTime);
  osc.frequency.exponentialRampToValueAtTime(720, ctx.currentTime + 0.07);
  g.gain.setValueAtTime(0.12, ctx.currentTime);
  g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.13);
  osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.14);
}

function playWinSound() {
  const ctx = getAudioCtx(); if (!ctx) return;
  // Ta-da: acorde C-E-G-C em escala ascendente rápida
  [[523.25,0],[659.25,0.09],[783.99,0.18],[1046.5,0.27]].forEach(([freq,when])=>{
    const osc = ctx.createOscillator(), g = ctx.createGain();
    osc.connect(g); g.connect(ctx.destination);
    osc.type = 'triangle';
    osc.frequency.value = freq;
    const t = ctx.currentTime + when;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.28, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, t + (when===0.27 ? 0.45 : 0.14));
    osc.start(t); osc.stop(t + 0.5);
  });
  // Bass punch no inicio
  const bass = ctx.createOscillator(), bg = ctx.createGain();
  bass.connect(bg); bg.connect(ctx.destination);
  bass.type = 'sine'; bass.frequency.value = 130;
  bg.gain.setValueAtTime(0.18, ctx.currentTime);
  bg.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
  bass.start(ctx.currentTime); bass.stop(ctx.currentTime + 0.2);
}

// ─── Confetti ───────────────────────────────────────────────

function useNotificationSound() {
  const playSound = React.useCallback(() => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const notes = [880, 660];
      notes.forEach((freq, i) => {
        const osc  = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, ctx.currentTime + i * 0.18);
        gain.gain.setValueAtTime(0, ctx.currentTime + i * 0.18);
        gain.gain.linearRampToValueAtTime(0.25, ctx.currentTime + i * 0.18 + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.18 + 0.3);
        osc.start(ctx.currentTime + i * 0.18);
        osc.stop(ctx.currentTime + i * 0.18 + 0.3);
      });
    } catch(e) {}
  }, []);
  return playSound;
}

export { getAudioCtx, playSwipeSound, playWinSound, useNotificationSound };
